import { compose } from 'recompose'
import withType from 'components/common/hoc/withType'
import BOTServiceCategoryDetails from './BOTServiceCategoryDetails'

export default compose(
  withType({ type: 'BOTServiceCategoryDetails' })
)(BOTServiceCategoryDetails)
